import { createSlice } from "@reduxjs/toolkit";
import { CreditStateProps } from "../interfaces/reducers";

const initialState: CreditStateProps = {
    fetching: "unknown",
    data: {},
    error: "",
    credit: {
        identifier: "",
        vehiclePrice: 0,
        creditType: "intelligent",
        foot: 0,
        fees: 48,
        model: ""
    },
    title: ""
};

const creditSlice = createSlice({
    name: "credit",
    initialState,
    reducers: {
        setCredit: (state, action) => {
            state.credit = action.payload;
        },
        getCreditRequest: (state) => {
            state.fetching = "loading";
        },
        getCreditSuccess: (state, action) => {
            state.fetching = "success";
            state.data = action.payload;
        },
        getCreditFailure: (state, action) => {
            state.fetching = "failure";
            state.error = action.payload;
        },
        cleanCredit: (state) => {
            state.fetching = initialState.fetching;
            state.credit = initialState.credit;
            state.data = initialState.data;
            state.error = initialState.error;
        },
        setCreditTitle: (state, action) => {
            state.title = action.payload;
        },
        cleanCreditTitle: (state) => {
            state.title = initialState.title;
        }   
    },
});

export const {
    setCredit,
    getCreditRequest,
    getCreditSuccess,
    getCreditFailure,
    cleanCredit,
    setCreditTitle,
    cleanCreditTitle
} = creditSlice.actions;

export default creditSlice.reducer;